import {t} from "i18next";
import {APP_WEB_WWW} from "@/electron_interactive";
import mitt from "mitt";
import {getCtrlOrAltCmd, isDarkMode} from "@/utils";
import global from "@/global";
import {isMacOs} from "react-device-detect";
import {isZh} from "@/language";

export enum VIEW_STYLE{
    VIEW_STYLE_GRID = 0,
    VIEW_STYLE_LIST = 1
}

/*树类型 目前是画布和笔记*/
export enum TREENODETYPE{
    TREE_NODE_TYPE_CANVAS = 0,
    TREE_NODE_TYPE_NOTES = 1
}

export const APP_NAME = "Noteey";
export const DEFAULT_CANVAS_BACKGROUND = '#EFEFEF';//'#F7F9FC';
export const DEFAULT_CANVAS_BACKGROUND_DARK = '#212327';//'#F7F9FC';

export const DEFAULT_ELEMENT_BG_ST_COLOR = "#2C2C2C";
export const DEFAULT_DRAW_ST_COLOR = "#E1E1E1"

export const FILTER_TAG_NO_TAGS = "noTags";

export const DEFAULT_CONTENT_MIN_HEIGHT = 34;

//todo 是否是启用stickynote的富文本框状态***
/**
 * 是否是启用stickynote的富文本框状态***
 *
 */
export const ENABLE_STICKYNOTE_RICHTEXT_20250815 = true;

export const getNoteElementBackgroundColor = ()=>{
    return isDarkMode()?"#2C2C2C":"#FFFFFF";
}
export const getNoteElementStrokeColor = ()=>{
    return isDarkMode()?'#2C2C2C':'#EFEFEF';
}

/**
 * 卡片默认边框
 */
export const getNoteElementStrokeColor250724 = ()=>{
    return isDarkMode()?'#666666':'#BAB8B8'
}

export const getProjectLinkElementStrokeColor250728 = ()=>{
    return isDarkMode()?'#666666':'#CECECEE0';
}

export const getProjectLinkElementBackground = ()=>{
    return isDarkMode()?"#2C2C2C":"#DEDEDE";
}

export const getShapeElementBackgroundColor = ()=>{
    return isDarkMode()?"#2C2C2C":"#FFFFFF";
}
export const getFrameElementBackgroundColor = ()=>{
    return isDarkMode()?"#393834":"#DBDBDB";
}
export const getShapeElementStrokeColor = ()=>{
    return isDarkMode()?'#2C2C2C':'#CECECE';
}

export const getMindmapRootTextColor = ()=>{
    return isDarkMode()?"#FFFFFF":"#23272E"
}
export const getMindmapSecondTextColor = ()=>{
    return isDarkMode()?"#CCCCCC":"#565656"
}
export const getBookmarkBackgroundColor = ()=>{
    return isDarkMode()?"#2C2C2C":"#FFFFFF";
}

/**
 * 选中元素的边框
 */
export const getElementSelectionBorderColor = ()=>{
    return '#3670F7';//isDarkMode()?'#DDDDDD':'#4B4B4B';
}

export const getInputBorderColor = ()=>{
    return isDarkMode()?'#DDDDDD':'#000000';
}

/**
 * 选中元素的边框
 */
export const getElementEditorBorderColor = ()=>{
    return isDarkMode()?'#DDDDDD':'#4B4B4B';
}

export const getDefaultTagBackgroundColor = ()=>{
    return isDarkMode()?DEFAULT_DARK_TAG_BACKGROUND_COLOR:DEFAULT_TAG_BACKGROUND_COLOR;
}
/**
 * 获取属性标签页的select tag的背景色，同一种颜色暗色和亮色颜色值不一样
 * @param szUseColor
 */
export const getPropertySelectOptionBackgroundColor = (szUseColor:any)=>{
    if (!szUseColor)return getDefaultTagBackgroundColor();
    const color = ARRAY_PROPERTY_OPTIONS_COLOR.find(p=>p.usedColor == szUseColor);
    if (color){
        return isDarkMode()?color?.useDarkColor:color?.usedColor;
    }
    return getDefaultTagBackgroundColor();
}

export const DEFAULT_TAG_BACKGROUND_COLOR = '#F4F5F6';
export const DEFAULT_DARK_TAG_BACKGROUND_COLOR = '#25282D';


export const DEFAULT_IMAGE_COLOR = "#393834";

export const DEFAULT_ATTR_SELECT_COLOR = "#E7E7E7";

export const COLOR_E5E5E5 = () =>{
    return global?.g_isDarkMode?"#383838":"#E5E5E5";
}

export const DEFAULT_ARROW_COLOR = "#706F6D"

export const DEFAULT_STICKYNOTE_BACKGROUND_COLOR = '#FDF59D'

export const COLOR_TRANSPARENT = "transparent";

export const COLOR_TOOL_BAR = "#FFFFFF";

export const FONT_DIR_NAME = "fonts";

export const COLOR_CHOOSE_TYPE_MINDMAP_LINE_COLOR = "mindmapLineColor";

export const BASE64_IMAGE_TRANSPARENT = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

export const BASE64_PLACEHOLDER =`data:image/jpeg;base64,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`;
export const BASE64_CANVAS_IMAGE_ERROR_PLACEHOLDER = `data:image/svg+xml,${encodeURIComponent(
    `<svg viewBox="0 0 668 668" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2"><path d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48ZM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56ZM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48Z" style="fill:#888;fill-rule:nonzero" transform="matrix(.81709 0 0 .81709 124.825 145.825)"/><path d="M256 8C119.034 8 8 119.033 8 256c0 136.967 111.034 248 248 248s248-111.034 248-248S392.967 8 256 8Zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676ZM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676Z" style="fill:#888;fill-rule:nonzero" transform="matrix(.30366 0 0 .30366 506.822 60.065)"/></svg>`,
)}`
export const BASE64_GIF = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAA0xJREFUeF7tm7FuE0EQhueQEILCLhxB5QoCSNC4JaCEInQWzxDT0KSkxqkp09DgvALIHRRxQdK6AYkQqFwlyhV2QYQoDk3QitOyvp3Zu93x4rvGzezezjf/zOzenRNY8itZcv+hBsBVwEma9pMkWc+ybIM71tX+0eHbna/dZ33X8UXjWApA5wHgpY+FFM358PAdJJB5gcAFkIV2Hu+HAPDyASEqAD4gRAegaghRAqgSQrQAqoIQNYAqIEQPoCyE/wJAGQhRABhMjmAw+WLdgrjsE6IAgJ77ghANAGv4cwY3Wi2yX2RDnP8kTUW2whzn0bYGIKmAxunri4Bd/vkdzptP4EdjkxvA0vZiCmhNXhgXn7ZflXaKM4EIgGuzD3B1+t64zl9XbsLs+nOOD6VsRQDMi77yJKQKagASRRCLHxY+0xW6GIooAJ1XHUCHQJU/7vY6zRZ0Givx1QC14nwxxOJ33twE/KVc6tnf7v21UhBEFEBxsMgmv9fvNFdg996a85TRATAddHrtu9Br33GCEBWA8ewMtj8dGB11TYWoAGx/PoDx9MwIwDUVFgaArapTzvguqbAwAIqqOsV5JQtuKiwEAFtVV3AoVY6bCuIAbFWdE30FiANBFICtqo+nKekBp0kZ1FQQBVAkbYzivIpPSQW0oUAQA+AibarjnFQQARDCeQXB1hpFAHCqOjfq3HoQHEDI6FNSISgACedtqRAMQFHLq0LmlDlMXSEYgNB5bwJi2iAFASApfR2EDiEIAIo8pWxqABKPxaWibbpvrQAfClgdDqL4NkAp4rjbI337QDLCSWsABQrAw4npjU6+VaINXvmPnfRxVbbWYAooOpnlHfr44OkFALV5Mo2LEoByzLZ4HQB1nGt3CaYA3bF5C54HwNd22gOAvX2Af/8mUyTt/GFpHgAFzKYgnhKS0XF36zFlTOkuYMttFeGwAADEFKCo2yRPTR1KFE02wQCo87je8tSbXZsC/NQADylwa7i3kUC2r9N2bYM+FcD5aJpcA/7sBs2FUIeAxU9/AaJvhEwbI1e558dxnMdxLAA44PbwTT+DJPh/B2lw6NJX87EB/IVwad3UFmkLrdoqGWUAO9+6WyPuzE4AuDdZZPulB/AbbyR3Xx28/K4AAAAASUVORK5CYII=";

export const MAP_WEEK:any = {"0": "Sun", "1": "Mon", "2": "Tue", "3": "Wed", "4": "Thu", "5": "Fri", "6": "Sat","7":"Sun"}
export const MAP_WEEK_FULL:any = {"0": "Sunday", "1": "Monday", "2": "Tuesday", "3": "Wednesday", "4": "Thursday", "5": "Friday", "6": "Saturday","7":"Sunday"}

export const MAP_MONTH:any = {"1":"Jan","2":"Feb","3":"Mar","4":"Apr","5":"May","6":"Jun","7":"Jul","8":"Aug","9":"Sep","10":"Oct","11":"Nov","12":"Dec"};
export const MAP_MONTH_FULL:any = {"1":"January","2":"February","3":"March","4":"April","5":"May","6":"June","7":"July","8":"August","9":"September","10":"October","11":"November","12":"December"};
/**
 * 自动保存间隔
 */
export let AUTO_SAVE_TIME_INTERVAL = 10000;
if (APP_WEB_WWW){
    AUTO_SAVE_TIME_INTERVAL = 1500;
}

export const MAX_SIZE = 1024*5*1024*1024;//5G .

export const MAX_IMAGE_FILE_SIZE = 20*1024*1024;

export const DEFAULT_TIPTAP_FONT_SIZE = 17;

export const DEFAULT_TIPTAP_FONT_SIZE_IN_CANVAS = 15;

//自定义的标题栏高度
export const TITLE_BAR_HEIGHT = 30;

//20Mb
export const SHARE_LIMIT_SIZE = 20;

export const MARGIN_TOP_CONTENT = 14;

//项目最多数量20个
export const MAX_HISTORY_COUNT = 20;
/**
 * 卡片最多10
 */
export const MAX_HISTORY_CARD_COUNT = 10;

export const MEDIIUM_Z_INDEX_666666 = 666666;
export const MEDIIUM_Z_INDEX = 888888;
export const MAX_Z_INDEX = 999999;

export const SEARCH_WIDTH = 178;

/**
 * 按钮的边距
 */
export const BUTTON_PADDING = '0 16px'

/**
 * 默认显示边框的粗细
 */
export const DEFAULT_ELEMENT_STROKE_WITHD = 4;

/**
 * 默认的embedable  bookmark -高度
 */
export const DEFAULT_EMBEDABLE_BOOKMARK_HEIGHT = 132;
export const DEFAULT_EMBEDABLE_BOOKMARK_WIDTH = 360;
export const DEFAULT_EMBEDABLE_ELEMENT_HEIGHT = 260;
export const DEFAULT_EMBEDABLE_ELEMENT_WIDTH = 530;

export const HAS_VIDEO_CAPTURE_TEST = true;

/**
 * infonotes底部的额外高度
 */
export const INFO_NOTES_EXTRA_HEIGHT = 20;

export const MAX_NOTES_HEIGHT = 220;

export const WIDTH_5 = 1380;
export const WIDTH_4 = 1000;
export const WIDTH_3 = 600;

/**
 * 库中存的一些特别的东西，永远不可见。
 */
export const DELETE_STATUS_FOR_HIDDEN_FOREVER = 9;

/**
 * 历史记录间隔分钟
 */
//todo 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换**************记得更换 记得更换 记得更换 记得更换 记得更换 记得更换
export const HISTORY_RECORD_TIME = 60*60*1000;//60分钟  测试1分钟--正式1小时
export const DB_AUTO_BACKUP_TIME = 6*60*60*1000; //测试1分钟--正式6小时
//todo 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换 记得更换**************记得更换 记得更换 记得更换 记得更换 记得更换 记得更换


export const ARRAY_DEFAULT_COLORS = ["#FFFFFF","#000000","#9D9D9F","#B36ED8","#407FDB","#59C457","#F4CE58","#F1A14E","#EC5C58"];

//- 以上改动只针对文本/形状/便利贴/思维导图节点的背景颜色
export const ARRAY_DEFAULT_COLORS_1 = ["#00000001","#FFFFFF","#9D9D9F","#B36ED8","#407FDB","#59C457","#F4CE58","#F1A14E","#EC5C58"];
//只有为边框添加颜色的时候才是这个....
export const ARRAY_DEFAULT_BORDER_COLORS = ["#00000001","#000000","#9D9D9F","#B36ED8","#407FDB","#59C457","#F4CE58","#F1A14E","#EC5C58"];

export const ARRAY_DEFAULT_CARD_COLORS = ["#FFFFFF","#000000","#B36ED8","#407FDB","#59C457","#F4CE58","#F1A14E","#EC5C58","#A00001"];
export const ARRAY_DEFAULT_USE_COLOR = {
    "#FFFFFF":"#FFFFFF",
    "#000000":"#D8D8D8",
    "#B36ED8":"#F6E9FC",
    "#407FDB":"#CADFFF",
    "#59C457":"#CCF0CC",
    "#F4CE58":"#FFF1C5",
    "#F1A14E":"#FFDFBD",
    "#EC5C58":"#FFC8C7",
    "#A00001":"#DEA9A9"
}
export const ARRAY_DEFAULT_DARK_USE_COLOR = {
    "#FFFFFF":"#565656",
    "#000000":"#292524",
    "#B36ED8":"#6C4780",
    "#407FDB":"#536C91",
    "#59C457":"#648A63",
    "#F4CE58":"#958552",
    "#F1A14E":"#9D6831",
    "#EC5C58":"#DA6461",
    "#A00001":"#A74647"
}

export const MAP_GROUP_BACKGROUND_COLOR:any = {
    "#F4F5F6":"#000000",
    "#E8E9ED":"#000000",
    "#FEE2E1":"#E4423C",
    "#DCFCE7":"#0F8236",
    "#DBEAFE":"#185AB1",
    "#FFF9C3":"#84710F",
    "#F3E9FF":"#782267",
    "#FBE7F3":"#6F3B16"
}
/**
 * 背景对应的icon
 */
export const MAP_GROUP_BACKGROUND_ICON:any = {
    "#E8E9ED":"tag_more_gray",
    "#FEE2E1":"tag_more_red",
    "#DCFCE7":"tag_more_green",
    "#DBEAFE":"tag_more_blue",
    "#FFF9C3":"tag_more_yellow",
    "#F3E9FF":"tag_more_purple",
    "#FBE7F3":"tag_more_pink"
}

export const ARRAY_DEFAULT_PROJECT_ITEM_THUMB = [
    "thumbnail_color1_light.png","thumbnail_colo2_light.png","thumbnail_color3_light.png","thumbnail_color4_light.png",
    "thumbnail_color5_light.png","thumbnail_color6_light.png","thumbnail_color7_light.png","thumbnail_color8_light.png",
    "thumbnail_color9_light.png","thumbnail_color10_light.png"
]
export const ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG = [
    "thumbnail_bg_color 1_light.png","thumbnail_color 2_light.png","thumbnail_bg_color 3_light.png","thumbnail_bg_color 4_light.png",
    "thumbnail_bg_color 5_light.png","thumbnail_bg_color 6_light.png","thumbnail_bg_color 7_light.png","thumbnail_bg_color 8_light.png",
    "thumbnail_bg_color 9_light.png","thumbnail_bg_color 10_light.png"
]

export const MAP_DEFAULT_PROJECT_ITEM_THUMB_BIG_COLOR:any = {
    "thumbnail_bg_color 1_light.png": {"light": "#FDE7F4", "dark": "#441C2D"},
    "thumbnail_color 2_light.png": {"light": "#FEF9C3", "dark": "#3D291C"},
    "thumbnail_bg_color 3_light.png": {"light": "#F5F3FF", "dark": "#28174A"},
    "thumbnail_bg_color 4_light.png": {"light": "#EDFFFF", "dark": "#1A303A"},
    "thumbnail_bg_color 5_light.png": {"light": "#FEF3F2", "dark": "#431D1F"},
    "thumbnail_bg_color 6_light.png": {"light": "#FFF7ED", "dark": "#41221B"},
    "thumbnail_bg_color 7_light.png": {"light": "#DBEAFE", "dark": "#1B274A"},
    "thumbnail_bg_color 8_light.png": {"light": "#FFFFFF", "dark": "#191B1F"},
    "thumbnail_bg_color 9_light.png": {"light": "#DCFCE8", "dark": "#193225"},
    "thumbnail_bg_color 10_light.png": {"light": "#F1F5F9", "dark": "#1B222D"}
}

export const ARRAY_DEFAULT_PROJECT_ITEM_THUMB_1 = [
    "icon_computer.png","icon_books.png","icon_pushpin.png","icon_torch.png",
    "icon_idea.png","icon_rocket.png","thumb_icon_note.png","icon_puzzle.png",
    "icon_pencil.png","icon_light.png","icon_dna.png",
    "icon_plane.png","icon_magnet.png","icon_paper.png"
]

export const DEFAULT_SHORTCUTS_CONFIG = [
    {name:'quickNotes',shortcuts:getCtrlOrAltCmd('Ctrl + E'),isPressed:false},
    {name:'newCard',shortcuts:getCtrlOrAltCmd('C'),isPressed:false},
    {name:'globalSearch',shortcuts:getCtrlOrAltCmd('Ctrl + K'),isPressed:false},
]

export const GET_DEFAULT_WEBVIEWER_CONFIG = ()=>{
    return  {
        defaultOpen:'noteeyWebviewer',
        defaultSearch:isZh()?'bing':'google',
        defaultUrl:''
    }
}

export const ARRAY_LIBRARY_TYPES_TABLEVIEW = ()=>{
    /**
     * 没有统一的类型--，不能设置统一的一个类型集合.每个地方不一样.
     */
    const ARRAY_LIBRARY_TYPES = [
        {
            value:'card',
            label:t("Card"),
            buttonLabel:t("New card"),
            icon:'library_type_card'
        },
        {
            value:'pdf',
            label:t("PDF"),
            buttonLabel:t("New PDF"),
            ext:'.pdf',
            icon:'library_type_pdf'
        },
        {
            value:'journal',
            label:t("Journal"),
            buttonLabel:t("New journal"),
            icon:'library_type_journal'
        },
        {
            value:'image',
            label:t("Image"),
            buttonLabel:t("New image"),
            ext:'.jpg,.jpeg,.bmp,.png',
            icon:'library_type_image'
        },
        {
            value:'liveVideo',
            label:t("Live video"),
            buttonLabel:'',
            ext:'.mp4,.mov',
            icon:'library_type_online_video'
        },
        {
            value:'video',
            label:t("Video"),
            buttonLabel:t("New video"),
            ext:'.mp4,.mov',
            icon:'library_type_video'
        },
        // {
        //     value:'image',
        //     label:t("Image"),
        //     buttonLabel:t("New image"),
        //     ext:'.jpg,.jpeg,.bmp,.png'
        // },
        {
            value:'audio',
            label:t("Audio"),
            buttonLabel:t("New audio"),
            ext:'.mp3',
            icon:'library_type_audio'
        },
        {
            value:'file',
            label:t("File"),
            buttonLabel:t("New file"),
            ext:'*',
            icon:'library_type_file'
        },
        {
            value:'webLink',
            label:t("Web link"),
            buttonLabel:t("Web link"),
            ext:'*',
            icon:'library_type_weblink'
        },
        {
            value:'cardAnno',
            label:t("Card highlight"),
            buttonLabel:t("Card highlight"),
            icon:'library_type_anno'
        },
        {
            value:'pdfAnno',
            label:t("PDF Highlight"),
            buttonLabel:t("PDF"),
            ext:'.pdf',
            icon:'library_type_anno'
        },
        {
            value:'videoAnno',
            label:t("Video notes"),
            buttonLabel:t("Video"),
            ext:'.mp4',
            icon:'library_type_anno'
        },
        {
            value:'audioAnno',
            label:t("Audio notes"),
            buttonLabel:t("Audio"),
            ext:'.mp3',
            icon:'library_type_anno'
        },
        {
            value:'project',
            label:t("Project"),
            buttonLabel:t(""),
            icon:'library_type_project'
        },
        {
            value:MENU_SEPARATOR,
            label:t(""),
            buttonLabel:'',
            ext:'*'
        },
        {
            value:CHECK_ALL,
            label:t("Select all"),
            buttonLabel:'',
            ext:'*',
            icon:'library_type_all'
        }
    ]
    return ARRAY_LIBRARY_TYPES;
}

export const ARRAY_LIBRARY_TYPES_LIBRARY = ()=>{
    const ARRAY_LIBRARY_TYPES = [
        {
            value:'card',
            label:t("Card"),
            buttonLabel:t("New card"),
            icon:'library_type_card'
        },
        {
            value:'pdf',
            label:t("PDF"),
            buttonLabel:t("New PDF"),
            ext:'.pdf',
            icon:'library_type_pdf'
        },
        {
            value:'journal',
            label:t("Journal"),
            buttonLabel:t("New journal"),
            icon:'library_type_journal'
        },
        {
            value:'image',
            label:t("Image"),
            buttonLabel:t("New image"),
            ext:'.jpg,.jpeg,.bmp,.png',
            icon:'library_type_image'
        },
        {
            value:'liveVideo',
            label:t("Live video"),
            buttonLabel:'',
            ext:'.mp4,.mov',
            icon:'library_type_online_video'
        },
        {
            value:'video',
            label:t("Video"),
            buttonLabel:t("New video"),
            ext:'.mp4,.mov',
            icon:'library_type_video'
        },
        {
            value:'audio',
            label:t("Audio"),
            buttonLabel:t("New audio"),
            ext:'.mp3',
            icon:'library_type_audio'
        },
        {
            value:'file',
            label:t("File"),
            buttonLabel:t("New file"),
            ext:'*',
            icon:'library_type_file'
        },
        {
            value:'webLink',
            label:t("Web link"),
            buttonLabel:t("Web link"),
            ext:'*',
            icon:'library_type_weblink'
        },
        {
            value:'cardAnno',
            label:t("Card highlight"),
            buttonLabel:t("Card highlight"),
            icon:'library_type_anno'
        },
        {
            value:'pdfAnno',
            label:t("PDF Highlight"),
            buttonLabel:t("PDF"),
            ext:'.pdf',
            icon:'library_type_anno'
        },
        {
            value:'videoAnno',
            label:t("Video notes"),
            buttonLabel:t("Video"),
            ext:'.mp4',
            icon:'library_type_anno'
        },
        {
            value:'audioAnno',
            label:t("Audio notes"),
            buttonLabel:t("Audio"),
            ext:'.mp3',
            icon:'library_type_anno'
        },
        {
            value:'project',
            label:t("Project"),
            buttonLabel:t("Audio"),
            ext:'.mp3',
            icon:'library_type_project.svg'
        },
        {
            value:MENU_SEPARATOR,
            label:t(""),
            buttonLabel:'',
            ext:'*'
        },
        {
            value:CHECK_ALL,
            label:t("Select all"),
            buttonLabel:'',
            ext:'*',
            icon:'library_type_all'
        }
    ]
    return ARRAY_LIBRARY_TYPES;
}

export const GET_ARRAY_LIBRARY_TYPES = ()=>{
    const ARRAY_LIBRARY_TYPES = [
        {
            value:'card',
            label:t("Card"),
            buttonLabel:t("New card"),
            icon:'library_type_card'
        },
        {
            value:'journal',
            label:t("Journal"),
            buttonLabel:t("New journal"),
            icon:'library_type_journal'
        },
        {
            value:'pdf',
            label:t("PDF"),
            buttonLabel:t("New PDF"),
            ext:'.pdf',
            icon:'library_type_pdf'
        },
        {
            value:'image',
            label:t("Image"),
            buttonLabel:t("New image"),
            ext:'.jpg,.jpeg,.bmp,.png',
            icon:'library_type_image'
        },
        {
            value:'liveVideo',
            label:t("Live video"),
            buttonLabel:'',
            ext:'.mp4,.mov',
            icon:'library_type_online_video'
        },
        {
            value:'video',
            label:t("Video"),
            buttonLabel:t("New video"),
            ext:'.mp4,.mov',
            icon:'library_type_video'
        },
        {
            value:'audio',
            label:t("Audio"),
            buttonLabel:t("New audio"),
            ext:'.mp3',
            icon:'library_type_audio'
        },
        {
            value:'file',
            label:t("File"),
            buttonLabel:t("New file"),
            ext:'*',
            icon:'library_type_file'
        },
        {
            value:'webLink',
            label:t("Web link"),
            buttonLabel:t("Web link"),
            ext:'*',
            icon:'library_type_weblink'
        },
        {
            value:'cardAnno',
            label:t("Card highlight"),
            buttonLabel:t("Card highlight"),
            icon:'library_type_anno'
        },
        {
            value:'pdfAnno',
            label:t("PDF Highlight"),
            buttonLabel:t("PDF"),
            ext:'.pdf',
            icon:'library_type_anno'
        },
        {
            value:'videoAnno',
            label:t("Video notes"),
            buttonLabel:t("Video"),
            ext:'.mp4',
            icon:'library_type_anno'
        },
        {
            value:'audioAnno',
            label:t("Audio notes"),
            buttonLabel:t("Audio"),
            ext:'.mp3',
            icon:'library_type_anno'
        },
        // {
        //     value:'project',
        //     label:t("Project"),
        //     buttonLabel:t("Project"),
        //     ext:'',
        //     icon:'library_type_project.svg'
        // }
    ]
    return ARRAY_LIBRARY_TYPES;
}



export const GET_ARRAY_SHORTCUTS = ()=>{
    const ARRAY_SHORTCUTS = [
        {
            id:'tool',
            name:t('Tool'),
            isChecked:true,
            children:[
                {
                    name:'SelectAndPan',
                    key:'H'
                },
                // {
                //     name:'Pan',
                //     key:'H'
                // },
                {
                    name:'Card',
                    key:'C'
                },
                {
                    name:'Text',
                    key:'T'
                },
                {
                    name:'Rectangle',
                    key:'R'
                },
                {
                    name:'Diamond',
                    key:'D'
                },
                {
                    name:'Ellipse',
                    key:'O'
                },
                {
                    name:'Arrow',
                    key:'A'
                },
                {
                    name:'Line',
                    key:'L'
                },
                {
                    name:'Draw',
                    key:'P'
                },
                {
                    name:'Highlighter',
                    key:'Ctrl P'
                },
                {
                    name:'Eraser',
                    key:'Ctrl R'
                },
                {
                    name:'Frame tool',
                    key:'F'
                },
                {
                    name:'Laser pointer',
                    key:'L'
                },

                {
                    name:'Pick colors from board',
                    key:'I'
                },
                {
                    name:'Edit text',
                    key:'Enter'
                },
                {
                    name:'Finish editing',
                    key:'Esc'
                },
                {
                    name:'Collapse/expand sidebar',
                    key:'Ctrl S'
                },
                {
                    name:'Add/update a link',
                    key:'Ctrl K'
                },
                {
                    name:'Library',
                    key:'Ctrl 1'
                }
            ]
        },
        {
            id:'view',
            name:t('View'),
            isChecked:false,
            children:[
                {
                    name:'Zoom in',
                    key:'Ctrl +'
                },
                {
                    name:'Zoom out',
                    key:'Ctrl -'
                },
                {
                    name:'Reset zoom',
                    key:'Ctrl 0'
                },
                {
                    name:'Zoom to fit all elements',
                    key:'1'
                },
                {
                    name:'Zoom to selection',
                    key:'2'
                },
                {
                    name:'Open card in popup mode',
                    key:'3'
                },
                {
                    name:'Toggle Floating Windows',
                    key:'Ctrl + W'
                },
                // {
                //     name:'Toggle light/dark mode',
                //     key:'Alt Shift D'
                // }
            ]
        },
        {
            id:'edit',
            name:t('Edit'),
            isChecked:false,
            children:[
                {
                    name:'Delete',
                    key:'Delete'
                },
                {
                    name:'Cut',
                    key:'Ctrl X'
                },
                {
                    name:'Copy',
                    key:'Ctrl C'
                },
                {
                    name:'Paste',
                    key:'Ctrl V'
                },
                // {
                //     name:'Duplicate',
                //     key:'Ctrl D or Alt drag'
                // },
                {
                    name:'Select all',
                    key:'Ctrl A'
                },
                {
                    name:'Add element to selection',
                    key:'Shift click'
                },
                {
                    name:'Deep select',
                    key:'Ctrl click'
                },
                {
                    name:'Search',
                    key:'Ctrl F'
                },
                {
                    name:'Move board',
                    key:'Space Drag'
                },
                {
                    name:'Reset the board',
                    key:'Ctrl Delete'
                },
                {
                    name:'Copy to clipboard as PNG',
                    key:'Shift Alt C'
                },
                {
                    name:'Copy styles',
                    key:'Ctrl Alt C'
                },
                {
                    name:'Paste styles',
                    key:'Ctrl Alt V'
                },
                {
                    name:'Send to back',
                    key:'Ctrl Shift ['
                },
                {
                    name:'Bring to front',
                    key:'Ctrl Shift ]'
                },
                {
                    name:'Send backward',
                    key:'Ctrl ['
                },
                {
                    name:'Bring forward',
                    key:'Ctrl ['
                },
                {
                    name:'Align top',
                    key:'Ctrl Shift Up'
                },
                {
                    name:'Align bottom',
                    key:'Ctrl Shift Down'
                },
                {
                    name:'Align left',
                    key:'Ctrl Shift Left'
                },
                {
                    name:'Align right',
                    key:'Ctrl Shift Right'
                },
                {
                    name:'Lock/unlock selection',
                    key:'Ctrl Shift L'
                },
                {
                    name:'Undo',
                    key:'Ctrl Z'
                },
                {
                    name:'Redo',
                    key:'Ctrl Y or Ctrl Shift Z'
                },
                {
                    name:'Group selection',
                    key:'Ctrl G'
                },
                {
                    name:'Ungroup selection',
                    key:'Ctrl Shift G'
                },
                {
                    name:'Flip horizontal',
                    key:'Shift H'
                },
                {
                    name:'Flip vertical',
                    key:'Shift V'
                },
                {
                    name:'Decrease font size',
                    key:'Ctrl Shift <'
                },
                {
                    name:'Increase font size',
                    key:'Ctrl Shift >'
                }
            ]
        }
    ]
    return ARRAY_SHORTCUTS;
}

export const arrayLanguages = [
    {
        key:"en",
        label:"English"
    },
    {
        key:"zh",
        label:"简体中文"
    },
    {
        key:"zh_tw",
        label:"繁体中文"
    },
    {
        key:"ja_jp",
        label:"日本語"
    },
    {
        key:"de_de",
        label:"Deutsch"
    }
];

export const ARRAY_TASKS = ()=>{
    const tasks = [
        {
            value:'today',
            label:t("Today"),
            icon:''
        },
        {
            value:'overdue',
            label:t("Overdue"),
            icon:''
        },
        {
            value:'upcoming',
            label:t("Upcoming"),
            icon:''
        },
        {
            value:'noDuedate',
            label:t("NoDuedate"),
            icon:''
        },
        {
            value:'complete',
            label:t("Completed"),
            icon:''
        },
    ]
    return tasks;
}

export const ARRAY_TASKS_FOR_TYPE_SWITCHER_LIST = ()=>{
    const tasks = [
        {
            value:'today',
            label:t("Today"),
            icon:''
        },
        {
            value:'upcoming',
            label:t("Upcoming"),
            icon:''
        },
        {
            value:'overdue',
            label:t("Overdue"),
            icon:''
        },

        {
            value:'noDuedate',
            label:t("NoDuedate"),
            icon:''
        },
        {
            value:'complete',
            label:t("Completed"),
            icon:''
        },
    ]
    return tasks;
}

export const HAS_ENABLE_TIPTAP_TEXT = true;


export const ARRAY_COLORS = [
    "#FFFFFF","#F9E7F2","#EEEFF8","#E6F2FC","#E9F4F5","#EFF5EE","#F8F9E7","#FDF2E6","#F8DFE0",
    "#EFEFEF","#DA7DB0","#8382BE","#85C2EB","#89CCD5","#AACF9E","#E4E47E","#FAD27B","#E3847E",
    "#B2B2B2","#DC0476","#4B68D1","#448CE0","#33B8C0","#65BF56","#C7D417","#EF7C16","#E41B21",
    "#706F6D","#A41154","#323E90","#2F6CB5","#189397","#40A435","#ADB912","#C5770F","#CA1617",
    "#1F0A0C","#3C0B20","#211F46","#1A2A47","#0B3D43","#19411F","#3E4519","#4E3013","#501011"];

export const ARRAY_COLORS_1 = ["#000000","#333333","#4F4F4F","#6C6C6C","#9A9A9A","#BEBEBE","#CECECE",DEFAULT_CANVAS_BACKGROUND,"#FFFFFF",
    "#EC808E","#EC808E","#FBCD90","#FEFC6D","#BFFB70","#9EFFFF","#81D3F7","#817EFF","#A678ED",
    "#CD1C14","#F59A23","#FFBD59","#FFF602","#87F410","#1FFDFF","#1EBBFF","#1832FF","#8400FE",
    "#A20113","#AB5F03","#D1A41E","#BEC100","#70B604","#00BFBE","#077CB4","#1200BF","#6400BF",
    "#6D000E","#7A4D13","#A07D1B","#818000","#4B7903","#028180","#025479","#080080","#420080"];

export const ARRAY_COLORS_DRAW = ["#000000","#333333","#6C6C6C","#9A9A9A","#868686","#BEBEBE","#CECECE","#EFEFEF","#FBFBFB",
    "#EC7F8E","#FFC06D","#FBCD90","#FEFC6D","#BFFB70","#9EFFFF","#81D3F7","#807EFF","#A678ED",
    "#CD1C14","#F59A23","#FFBD59","#FFF602","#8FF42A","#1EFDFF","#1FFDFF","#1732FF","#8500FE",
    "#A20113","#AB5F03","#D1A41E","#BFC100","#70B604","#03BFBE","#0A7CB4","#1100BF","#6400BF",
    "#6D010E","#7A4D13","#A17D1B","#818000","#4A7903","#028180","#005479","#090080","#420080"];

export const ARRAY_COLORS_MAIN = [
    "#FFFFFF","#F9E7F2","#EEEFF8","#E6F2FC","#E9F4F5","#EFF5EE","#F8F9E7","#FDF2E6","#F8DFE0",
    "#EFEFEF","#DA7DB0","#8382BE","#85C2EB","#89CCD5","#AACF9E","#E4E47E","#FAD27B","#E3847E",
    "#B2B2B2","#DC0476","#4B68D1","#448CE0","#33B8C0","#65BF56","#C7D417","#EF7C16","#E41B21",
    "#706F6D","#A41154","#323E90","#2F6CB5","#189397","#40A435","#ADB912","#C5770F","#CA1617",
    "#1F0A0C","#3C0B20","#211F46","#1A2A47","#0B3D43","#19411F","#3E4519","#4E3013","#501011"];

/**
 * 属性中options的颜色，又用不一样的？？？？
 */
export const ARRAY_PROPERTY_OPTIONS_COLOR = [
    {color:'#F9E7F2',usedColor:'#F9E7F2',useDarkColor:'#6B3C59',color0:''},//ff9500
    {color:'#EEEFF8',usedColor: '#EEEFF8',useDarkColor:'#32386A',color0:''},
    {color:'#E6F2FC',usedColor: '#E6F2FC',useDarkColor:'#254765',color0:''},
    {color:'#E9F4F5',usedColor: '#E9F4F5',useDarkColor:'#123D42',color0:''},
    {color:'#EFF5EF',usedColor: '#EFF5EF',useDarkColor:'#264626',color0:''},
    {color:'#F8F9E7',usedColor: '#F8F9E7',useDarkColor:'#535431',color0:''},
    {color:'#F8DFE0',usedColor: '#F8DFE0',useDarkColor:'#4A191B',color0:''},
    {color:'#FDF2E6',usedColor: '#FDF2E6',useDarkColor:'#4F3218',color0:''}
]

export const CARD_HIGHLIGHT_COLOR=[
    {color:'#ffd400',usedColor:'#FCEC96',useDarkColor:'#BDAA47',color0:''},//ff9500
    {color:'#ff6666',usedColor: '#F5BEBB',useDarkColor:'#E59894',color0:'#FF6666'},
    {color:'#5fb236',usedColor: '#BEDAA9',useDarkColor:'#98BD7C',color0:''},
    {color:'#2ea8e5',usedColor: '#ABD5F1',useDarkColor:'#6CA2C6',color0:''},
    {color:'#a28ae5',usedColor: '#D3CAF1',useDarkColor:'#A99CD4',color0:''},
    {color:'#e56eee',usedColor: '#EBC1F4',useDarkColor:'#CB93D7',color0:''},
    {color:'#f19837',usedColor: '#F2D2A9',useDarkColor:'#D7AF7C',color0:''},
    {color:'#aaaaaa',usedColor: '#D8D8D8',useDarkColor:'#8E8E8E',color0:''}]

/**
 * 浅色和暗色的MAP
 */
export const MAP_HIGHLIGHT_COLOR_L_2_D:any = {
    '#FCEC96':'#BDAA47',
    '#F5BEBB':'#E59894',
    '#BEDAA9':'#98BD7C',
    '#ABD5F1':'#6CA2C6',
    '#D3CAF1':'#A99CD4',
    '#EBC1F4':'#CB93D7',
    '#F2D2A9':'#D7AF7C',
    '#D8D8D8':'#8E8E8E',
}
export const MAP_HIGHLIGHT_COLOR_D_2_L:any = {
    '#BDAA47':'#FCEC96',
    '#E59894':'#F5BEBB',
    '#98BD7C':'#BEDAA9',
    '#6CA2C6':'#ABD5F1',
    '#A99CD4':'#D3CAF1',
    '#CB93D7':'#EBC1F4',
    '#D7AF7C':'#F2D2A9',
    '#8E8E8E':'#D8D8D8',
}

export const highlightDarkColorToLight = (szColor:any)=>{
    let szNewColor = MAP_HIGHLIGHT_COLOR_D_2_L[szColor];
    if (!szNewColor){
        szNewColor = szColor;
    }
    return szNewColor;
}

export const ARRAY_IFRAME_SIZE = [
    {
        id: "16:9",
        title: "16:9",
        isActive: false,
        type: "frame",
        pageSize: [16, 9],
        imageName: 'page_size_presentation.png'
    },
    {
        id: "4:3",
        title: "4:3",
        isActive: false,
        type: "frame",
        pageSize: [4, 3],
        imageName: 'page_size_tv.png'
    },
    {
        id: "1:1",
        title: "1:1",
        isActive: false,
        type: "frame",
        pageSize: [1, 1],
        imageName: 'page_size_square.png'
    },
    {
        id: "9:16",
        title: "9:16",
        isActive: false,
        type: "frame",
        pageSize: [9, 16],
        imageName: 'page_size_portrait.png'
    },
    {
        id: "A4",
        title: "A4",//(210*297mm)
        isActive: false,
        type: "frame",
        pageSize: [210, 297],
        imageName: 'page_size_a4.png'
    },
    {
        id: "US Letter",
        title: "US Letter",//(215.9*294.4mm)
        isActive: false,
        type: "frame",
        pageSize: [215.9, 294.4],
        imageName: 'page_size_letter.png'
    },

    {
        id: "Custom Size",
        title: t("Custom size"),
        isActive: false,
        type: "frame",
        pageSize: null,
        imageName: 'page_size_custom.png'
    },
];

export const DEFAULT_PROPERTY = [
    {
        id:'name',
        name:'Name',
        groupName:'default',
        propertySort:-1,
        icon:'property_text',
        type:'text'
    },
    {
        id:'createTime',
        name:'Create time',
        groupName:'default',
        propertySort:0,
        icon:'property_create_time',
        type:'date'
    },
    {
        id:'updateTime',
        name:'Update time',
        groupName:'default',
        propertySort:1,
        icon:'property_update_time',
        type:'date'
    },
    {
        id:'infoNotes',
        name:'Notes',
        groupName:'default',
        propertySort:2,
        icon:'property_notes',
        type:'text'
    },
    {
        id:'infoUrl',
        name:'Link',
        groupName:'default',
        propertySort:3,
        icon:'property_link',
        type:'text'
    },
    // {
    //     id:'project',
    //     name:'Project',
    //     groupName:'default',
    //     propertySort:4,
    //     icon:'property_project',
    //     type:'project'
    // },
    {
        id:'tags',
        name:'Tags',
        groupName:'default',
        propertySort:5,
        icon:'property_tags',
        type:'tags'
    },
    {
        id:'type',
        name:'Type',
        groupName:'default',
        propertySort:6,
        icon:'property_type',
        type:'type'
    },
]

export const ARRAY_PROPERTY_TYPE = ()=>{
    return [
        {
            id:'text',
            name:t('Text'),
            icon:'property_text'
        },
        {
            id:'number',
            name:t('Number'),
            icon:'property_number'
        },
        {
            id:'select',
            name:t('Select'),
            icon:'property_select'
        },
        {
            id:'multiSelect',
            name:t('MultiSelect'),
            icon:'property_multi_select'
        },
        {
            id:'date',
            name:t('Date'),
            icon:'property_date'
        },
        {
            id:'checkbox',
            name:t('Checkbox'),
            icon:'property_checkbox'
        },
        {
            id:'url',
            name:t('URL'),
            icon:'property_url'
        },
        {
            id:'rating',
            name:t('Rating'),
            icon:'property_rating'
        }
    ]
}



/**
 * 使用的浅颜色转换为要显示的深颜色
 * @param szUserdColor
 */
export const usedColorToShowColor = (szUserdColor:any,thisOtherDefaultYellowColor=null)=>{
    if (!szUserdColor)return '';
    szUserdColor = szUserdColor.toUpperCase();
    if (szUserdColor == '#FFD400' || szUserdColor == '#FCEC96'){
        if (thisOtherDefaultYellowColor){//一点颜色值，这样，那样的换。。。。
            return thisOtherDefaultYellowColor;
        }
        return '#FF9500';
    }
    let c = CARD_HIGHLIGHT_COLOR.find(p=>p.usedColor == szUserdColor);
    if (c){
        return c.color;
    }
    return szUserdColor;
}
 /**
 * 列和数据字段的对应关系...
 */
 export const MAP_COLUMN_DATAS:any = {
    notes:'infoNotes',
    link:'infoUrl'
}


export const arrayDarkMenu = ()=>{
    return [{
        key:'dark',
        label:t('Dark')
    },{
        key:'light',
        label:t('Light')
    }];
}

export const arrayDoubleClickMenu = ()=> {
    return [
        {
            key: 'card',
            label: t('Card')
        },
        {
            key: 'text',
            label: t('Text')
        },
        {
            key: 'stickyNote',
            label: t('Sticky notes')
        },
        {
            key: 'none',
            label: t('None')
        },
        // {
        //     key: 'rectangle',
        //     label: t('Rectangle')
        // }
    ];
}

export const arrayVisiblityMenu = ()=>{
    return [{
        key:'visible',
        label:t('Visible')
    },{
        key:'invisible',
        label:t('Invisible')
    }];
}

export const arrayConnectorTypeMenu = ()=>{
    return [{
        key:'curve',
        label:t('Curve')
    },
        {
            key:'elbow',
            label:t('Elbow')
        },{
        key:'straight',
        label:t('Straight line')
    }];
}

export const arrayCardDisplayModeMenu = ()=>{
    return [{
        key:'sidePanel',
        label:t('Side panel')
    },{
        key:'popupWindow',
        label:t('Popup window')
    }];
}

export const arrayOnOff = ()=>{
    return [{
        key:'on',
        label:t('On')
    },{
        key:'off',
        label:t('Off')
    }];
}

export const arrayDefaultNoCookie = ()=>{
    return [{
        key:'default',
        label:t('Default')
    },{
        key:'noCookie',
        label:t('No cookie')
    }];
}

export const arrayDefaultWebviewerOpen = ()=>{
    return [{
        key:'noteeyWebviewer',
        label:t('NoteeyWebViewer')
    },{
        key:'browse',
        label:t('Browse')
    }];
}

export const arrayDefaultSearchEngine = ()=>{
    return [{
        key:'google',
        label:t('Google')
    },{
        key:'bing',
        label:t('Bing')
    },{
        key:'baidu',
        label:t('Baidu')
    }];
}

export const DEFAULT_IMPORT_MODE =() =>{
    return[
        {
            id:'importMode',
            title:t("Copy mode"),
            tips:t("CopyTheFileToYourLibrary"),
            img:'file_mode_import',
            isHover:false
        },
        {
            id:'linkMode',
            title:t("Link mode"),
            tips:t("AccessOriginalFileWithout"),
            img:'file_mode_link',
            isHover:false
        }
    ]
}

/**
 * 显示显示的左侧菜单
 */
export const DEFAULT_HOME_LEFT_MENU = {home:true,projects:true,journal:true,library:true,tags:true,highlights:true,properties:true,favor:true,recent:true};

export const INIT_ID_GETTING_START_0 = "init_info_0";

//desktop pro的来源...
export const DESKTOP_PRO_FROM_IMPORT_FILE = "import file";
export const DESKTOP_PRO_FROM_IMPORT_BACKUP_FILE = "import backup file";
export const DESKTOP_PRO_FROM_IMPORT_FONT = "import font";
export const DESKTOP_PRO_FROM_PDF_ANNO = "pdf anno";
export const DESKTOP_PRO_FROM_OCR = "ocr";
export const DESKTOP_PRO_FROM_LASER_POINTER = "laser pointer";
export const DESKTOP_PRO_FROM_REMOVE_WATERMARK = "remove watermark";
export const DESKTOP_PRO_FROM_UPGRADE = "DESKTOP_PRO_FROM_UPGRADE";
//end


export const FILTER_PROJECT_ID_ALL = "all";
export const FILTER_PROJECT_ID_ALL_0 = "all-0";
export const FILTER_PROJECT_ID_ALL_IN_PROJECT = "allInProject";
export const FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL = "notInProject";
export const FILTER_PROJECT_CURRENT_PROJECT = "currentProject";
export const FILTER_PROJECT_CURRENT_BOARD = "currentBoard";
export const CHECK_ALL = "checkAll";

/**
 * 默认分页大小
 */
export const PAGE_SIZE = 30;

/**
 * 文件一次最多的导入数量
 */
export const MAX_IMPORT_FILE_SIZE = 20;

//头部的高度---drawindex.css   .headerStyle{
export const HEADER_HEIGHT = 46;

//首页右侧各page页距顶的边距
export const PAGE_TITLE_MARGIN_TOP = 16;

export const LEFT_MENU_WIDTH = 241;//241

export const HOME_LEFT_MENU_WIDTH = 287;

export const TOOL_BAR_LEFT_WIDTH = 240;//240

export const DRAW_TOOL_POPOVER_TOP = '128px'

//选中元素的弹出菜单Y偏移
export const ELEMENT_POPOVER_TOOLS_OFFSET_Y = 8;

export const DEFAULT_TOOLBAR_HEIGHT = 36;

export const DEFAULT_COLLAPSE_HEIGHT = 40;
export const DEFAULT_COLLAPSE_HEIGHT_1 = 38;

export const RESPONSE_LAYOUT_L1 = 1400 + 300;
export const RESPONSE_LAYOUT_L2 = 1900 + 300;

export const MAX_CARD_COUNT = 100;

export const DROPDOWN_MIN_WIDTH = 168;

export const DEFAULT_AUDIO_WIDTH = 340;
export const DEFAULT_AUDIO_HEIGHT = 90;

export const CARD_MAX_PASTE_SIZE = 500*1000;

//东西又多，又要拉到最小。原极限384   现420---》  增加了anno 的 source 选项
export const DEFAULT_SLIDER_WIDTH = 420;
export const DEFAULT_SLIDER_PDF_WIDTH = 420;
export const DEFAULT_SLIDER_LIBRARY_WIDTH = 420;
export const DEFAULT_SLIDER_COMMON_WIDTH = 420;

//画布工具栏高度
export const DRAW_TOOLS_HEIGHT = isMacOs?'50px':'80px';
export const DRAW_TOOLS_HEIGHT_WIN = '90px';

export const POPOVER_TOOLS_TOP = '79px';

export const PUBLISH_FRAME_SUF = "--f";

export const MENU_SEPARATOR = "separator";

export const LASTEST_NOTE_DOC = "LASTEST_NOTE_DOC";
export const KEY_MINDMAP_STYLE_CONFIG = "KEY_MINDMAP_STYLE_CONFIG";
export const KEY_FILE_DIR = "KEY_FILE_DIR";
export const KEY_CARD_ELEMENT_DEFAULT_STYLE = "KEY_CARD_ELEMENT_DEFAULT_STYLE";
export const KEY_LAST_CARD_FONT_COLOR = "KEY_LAST_CARD_FONT_COLOR";
export const KEY_ANNO_TYPES = "KEY_ANNO_TYPES";
export const KEY_AUTO_SAVE_CLOUD_DB = "autoSaveToCloudDb"
export const KEY_DONOT_SHOW_REMOVE_IMAGE_TIP = "KEY_DONOT_SHOW_REMOVE_IMAGE_TIP";
export const KEY_IS_ENABLE_SYNC = "isEnableSync";
export const KEY_PROJECT_TAB_ID = "KEY_PROJECT_TAB_ID";
export const KEY_LIBRARY_TAB_ID = "KEY_LIBRARY_TAB_ID";
export const KEY_JOURNAL_SELECT_DATE = "KEY_JOURNAL_SELECT_DATE"
export const KEY_JOURNAL_SELECT_VIEW = "KEY_JOURNAL_SELECT_VIEW";
export const KEY_SHOW_HIDIN_CARDS = "KEY_SHOW_HIDIN_CARDS";
export const KEY_SHOW_HIDIN_PROJECTS = "KEY_SHOW_HIDIN_PROJECTS";
export const KEY_SELECT_RIGHT_SLIDER_MENU = "selectRightSliderMenu";
export const KEY_IS_FIRST_OPEN_LIBRARY_REF = "isFirstOpenLibraryRef";
export const KEY_ISCTRL_CMD_PRESSED = "KEY_ISCTRL_CMD_PRESSED";

export const KEY_HAS_SHOWED_NOTE_SLIDER_TIPS = "KEY_HAS_SHOWED_NOTE_SLIDER_TIPS";

export const KEY_FILTER_SELECT_PROJECT = "KEY_FILTER_SELECT_PROJECT";
export const KEY_FILTER_SELECT_TAG = "KEY_FILTER_SELECT_TAG";
export const KEY_FILTER_CUSTOM_FILTER = "KEY_FILTER_CUSTOM_FILTER";
export const KEY_TYPE_SWITCHER = "KEY_TYPE_SWITCHER";
export const KEY_TASK_TYPE_SWITCHER = "KEY_TASK_TYPE_SWITCHER";
export const KEY_TASK_FILTER_TYPE = "KEY_TASK_FILTER_TYPE";
export const KEY_DEFAULT_STICKYNOTE_BACKGROUND_COLOR = "KEY_DEFAULT_STICKYNOTE_BACKGROUND_COLOR"
export const KEY_DEFAULT_TEXT_BACKGROUND_COLOR = "KEY_DEFAULT_TEXT_BACKGROUND_COLOR";
export const KEY_DEFAULT_TEXT_FONT_FAMILY = "KEY_DEFAULT_TEXT_FONT_FAMILY";
export const KEY_DEFAULT_TEXT_FONT_SIZE = "KEY_DEFAULT_TEXT_FONT_SIZE";

export const KEY_TAG_LIST_FILTER_SELECT_TAG = "KEY_TAG_LIST_FILTER_SELECT_TAG";

export const KEY_FILTER_SELECT_PROJECT_HIGHLIGHT = "KEY_FILTER_SELECT_PROJECT_HIGHLIGHT";
export const KEY_FILTER_SELECT_TAG_HIGHLIGHT = "KEY_FILTER_SELECT_TAG_HIGHLIGHT";

export const KEY_USE_SCROLL_WHEEL_ZOOM = "useScrollWheelZoom";

export const KEY_TRANSCRIPT_AUTO_SCROLL = "transcriptAutoScroll";
export const KEY_TRANSCRIPT_IS_EXPAND = "transcriptIsExpand";
export const KEY_TRANSCRIPT_DIALOG_HAS_BANNER = "transcriptHasBanner";

export const DEFAULT_NOTE_WIDTH = 340;
export const DEFAULT_NOTE_HEIGHT = 166;
export const DEFAULT_NOTE_HEIGHT_1 = 184;
export const DEFAULT_NOTE_HEIGHT_2 = 454;

export const DEFAULT_STICK_NOTE_WIDTH = 300;
export const DEFAULT_STICK_NOTE_HEIGHT = 300;

export const DEFAULT_TEXT_WIDTH = 300;
export const DEFAULT_TEXT_HEIGHT = 46;

export const MAX_AUTO_CARD_EDIT_HEIGHT = 400;

export const PROJECT_THUMB_W_H = 0.68;//项目缩略图w/h
export const PROJECT_THUMB_DEFAULT_HEIGHT = 159;
// export const KEY_NEW_USER_
export const HOVER_CIRCLE_ELEMENT_SIZE = 30;

/**
 * 笔记修改事件
 */
export const EVENT_NOTE_CHANGED = "note-change";

export const FILTER_NO_TAGS_NO_TAGS_______ = "noTags-----";

export const EVENT_ORIGIN_KEY = "EVENT_ORIGIN_KEY";

export const EVENT_CLOSE_IFRAME_DRAWINDEX = "EVENT_CLOSE_IFRAME_DRAWINDEX";

export const EVENT_DIALOG_DRAW_INDEX_ISFULLSCREEN = "EVENT_DIALOG_DRAW_INDEX_ISFULLSCREEN";

export const EVENT_CARD_CLOSED = "EVENT_CARD_CLOSED";

export const EVENT_OPEN_NOTE = "EVENT_OPEN_NOTE";

export const EVENT_UPDATE_PDF_NAME = "EVENT_UPDATE_PDF_NAME";

export const EVENT_TOOLBAR_LOCKED_CHANGED = "EVENT_TOOLBAR_LOCKED_CHANGED";

export const EVENT_RESET_SEARCH = "resetSearch";
/**
 * 画布中删除子笔记
 */
export const EVENT_CANVAS_DELETE_ELEMENT = "canvas-delete-element";

/**
 * 画布选中时选中左侧列表
 */
export const EVENT_CANVAS_SELECT_IFRAME = "canvas-select-iframe";

/**
 * 复制时新创建element
 */
export const EVENT_CANVAS_COPY_ADD_IFRAME = "canvas-copy-add-iframe";

/**
 * 收藏修改
 */
export const EVENT_FAVIRIATE_CHANGE = "favirate-change";

export const EVENT_REFRESH_RECENTS = "EVENT_REFRESH_RECENTS";

export const EVENT_REFRESH_VIDEO_TITLE = "EVENT_REFRESH_VIDEO_TITLE";

export const EVENT_REFRESH_DEEPLINK_TITLE = "EVENT_REFRESH_DEEPLINK_TITLE";

export const EVENT_REFRESH_DEEPLINK = "EVENT_REFRESH_DEEPLINK";

export const EVENT_COPY_DOC_NOTE="EVENT_COPY_DOC_NOTE";

/**
 * 在元素上复制笔记，需要反向创建笔记...
 */
export const EVENT_COPY_DOC_NOTE_FROM_ELEMENT = "EVENT_COPY_DOC_NOTE_FROM_ELEMENT";

export const EVENT_ADD_NOTE_BY_CARD = "EVENT_ADD_NOTE_BY_CARD";

export const EVENT_PASTE_DEEP_LINK = "EVENT_PASTE_DEEP_LINK";

export const EVENT_PASTE_URL = "EVENT_PASTE_URL";

export const  EVENT_PASTE_MINDMAP_PLAINT_TEXT = "EVENT_PASTE_MINDMAP_PLAINT_TEXT";

export const EVENT_DELETE_LEFT_CARD = "EVENT_DELETE_LEFT_CARD";

export const EVENT_REFRESH_CONTENT_BOOKMARK_ = "EVENT_REFRESH_CONTENT_BOOKMARK_"

export const EVENT_DELETE_LEFT_CARD_BAT = "EVENT_DELETE_LEFT_CARD_BAT";

export const EVENT_COPY_MINDMAP_FROM_ELEMENT = "EVENT_COPY_MINDMAP_FROM_ELEMENT";

export const EVENT_FORCE_UPDATE_MINDMAP = "EVENT_FORCE_UPDATE_MINDMAP"

export const EVENT_OPEN_VIDEO_IN_POPUP = "EVENT_OPEN_VIDEO_IN_POPUP";

export const EVENT_UPDATE_MEDIA_ELEMENT_SRC = "EVENT_UPDATE_MEDIA_ELEMENT_SRC";

export const EVENT_FRAME_PREVIEW_LAST = "EVENT_FRAME_PREVIEW_LAST";
export const EVENT_FRAME_PREVIEW_NEXT = "EVENT_FRAME_PREVIEW_NEXT";
export const EVENT_FRAME_PREVIEW_BY_ID = "EVENT_FRAME_PREVIEW_BY_ID";
export const EVENT_FRAME_PAGES = "EVENT_FRAME_PAGES";

export const EVENT_NAVIGATE_DEEPLINK = "EVENT_NAVIGATE_DEEPLINK";

export const EVENT_FRAME_PAGE_DESC_VISIBLE = "EVENT_FRAME_PAGE_DESC_VISIBLE";

//导出的zip文件包含的实际数据的内容，防止有文件重名....
export const ZIP_DATA_DB_NAME = "data.db_noteey_data";


/**
 * 笔记删除
 */
export const EVENT_NOTE_DELETE = "note-delete";

/**
 * 永久删除
 */
export const EVENT_NOTE_DELETE_FOREVER = "note-delete-forever";

/**
 * 全屏保存
 */
export const EVENT_NOTE_FULLSCREEN_SAVE = "note-fullscreen-save";

/**
 * 重命名画布的子笔记
 */
export const POST_MESSAGE_RENAME_SUB_NOTENAME = "rename-sub-note-name";

export const EVENT_RENAME_PAGES = "EVENT_RENAME_PAGES";

export const EVENT_FORCE_UPDATE = "EVENT_FORCE_UPDATE";

export const EVENT_REFRESH_CANVAS = "EVENT_REFRESH_CANVAS"

export const EVENT_REFRESH_FAVOR = "EVENT_REFRESH_FAVOR";

export const EVENT_RENAME_LIBRARY_ITEM = "EVENT_RENAME_LIBRARY_ITEM";

export const EVENT_REFRESH_PDF_ANNO_COMMENT = "EVENT_REFRESH_PDF_ANNO_COMMENT";

export const EVENT_REFRESH_ANNO_NAME = "EVENT_REFRESH_ANNO_NAME";

export const EVENT_REFRESH_CURRENT_CANVAS = "EVENT_REFRESH_CURRENT_CANVAS"

export const EVENT_AUTO_UPDATE_IS_READY = "EVENT_AUTO_UPDATE_IS_READY";
export const EVENT_AUTO_UPDATE_INFO = "EVENT_AUTO_UPDATE_INFO";

export const POST_MESSAGE_REFRESH_FOLDER_LIST = "POST_MESSAGE_REFRESH_FOLDER_LIST";

/*更新文件夹名称*/
export const EVENT_UPDATE_FOLDER_NAME = "EVENT_UPDATE_FOLDER_NAME";

/*选中左侧文件夹ge */
export const EVENT_SELECTED_FOLDER = "EVENT_SELECTED_FOLDER";
export const EVENT_UPDATE_NOTE = "EVENT_UPDATE_NOTE";
export const EVENT_REFRESH_TAG_LSIT = "EVENT_REFRESH_TAG_LSIT";
export const EVENT_SYNC_CARD_DATA_FROM_PAGECARD = "EVENT_SYNC_CARD_DATA_FROM_PAGECARD";
export const EVENT_REFRESH_JOURNAL = "EVENT_REFRESH_JOURNAL";
export const EVENT_SYNC_CARD_DATA_FROM_RIGHT_SLIDER = "EVENT_SYNC_CARD_DATA_FROM_RIGHT_SLIDER";
export const EVENT_SYNC_JOURNAL_DATA_FROM_PAGEJOURNAL = "EVENT_SYNC_JOURNAL_DATA_FROM_PAGEJOURNAL";
export const EVENT_SYNC_JOURNAL_DATA_FROM_RIGHT_SLIDER = "EVENT_SYNC_JOURNAL_DATA_FROM_RIGHT_SLIDER";
export const EVENT_SYNC_REFRESH_DRAW_CARDEDIT = "EVENT_SYNC_REFRESH_DRAW_CARDEDIT";
export const EVENT_REFRESH_HOME_LEFT_MENU = "EVENT_REFRESH_HOME_LEFT_MENU";

export const EVENT_SYNC_NOTE_DATA = "EVENT_SYNC_NOTE_DATA";
export const EVENT_REFRESH_INFO = "EVENT_REFRESH_INFO";
export const EVENT_SAVE_CARD = "EVENT_SAVE_CARD";
export const EVENT_UPDATE_HIGHLIGHT_ANNO = "EVENT_UPDATE_HIGHLIGHT_ANNO";
export const EVENT_UPDATE_TAG = "EVENT_UPDATE_TAG";
export const EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD = "EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD";
export const EVENT_ACTIVE_CARD_EDIT = "EVENT_ACTIVE_CARD_EDIT";
export const EVENT_RESIZING_CARD = "EVENT_RESIZING_CARD";
export const EVENT_REFRESH_EDIT_CARD = "EVENT_REFRESH_EDIT_CARD";
export const EVENT_REFRESH_EDIT_CARD_NEW = "EVENT_REFRESH_EDIT_CARD_NEW";
export const EVENT_OPEN_OUT_APP_DATA = "EVENT_OPEN_OUT_APP_DATA";
export const EVENT_RESET_NOTE_DATA = "EVENT_RESET_NOTE_DATA";
export const EVENT_CARD_BLOCK_JUMP = "EVENT_CARD_BLOCK_JUMP";
export const EVENT_OPEN_IMAGE_ACTION = "EVENT_OPEN_IMAGE_ACTION";
export const EVENT_CLOSE_IMAGE_ACTION = "EVENT_CLOSE_IMAGE_ACTION";
export const EVENT_ADD_NOTE = "EVENT_ADD_NOTE";
export const EVENT_UPDATE_PROGRESS = "EVENT_UPDATE_PROGRESS";
export const EVENT_KEYDOWN = "EVENT_KEYDOWN";
export const EVENT_REDICTER_TO_DRAW = "EVENT_REDICTER_TO_DRAW";
export const EVENT_RESET_NO_SELECTED = "EVENT_RESET_NO_SELECTED";

export const EVENT_REFRESH_LIBRARY_LIST = "EVENT_REFRESH_LIBRARY_LIST";
export const EVENT_REFRESH_SLIDER_INFO = "EVENT_REFRESH_SLIDER_INFO";
export const EVENT_REFRESH_VIDEO_NOTE = "EVENT_REFRESH_VIDEO_NOTE";
export const EVENT_REFRESH_HIGHLIGHT_LIST = "EVENT_REFRESH_HIGHLIGHT_LIST";
export const EVENT_REFRESH_VIDEO_ANNO_ELEMENT = "EVENT_REFRESH_VIDEO_ANNO_ELEMENT";
export const EVENT_REFRESH_LIBRARY_TAG_LIST = "EVENT_REFRESH_LIBRARY_TAG_LIST";
export const EVENT_REFRESH_INFO_TAG = "EVENT_REFRESH_INFO_TAG";
export const EVENT_LANGUAGE_CHANGED = "EVENT_LANGUAGE_CHANGED";
export const EVENT_BOARD_CHANGED = "EVENT_BOARD_CHANGED";
export const EVENT_ISFULL_SCREEN = "EVENT_ISFULL_SCREEN";

export const EVENT_CLOSE_SEARCH_STATS = "EVENT_CLOSE_SEARCH_STATS";

export const EVENT_LICENSE_ACTIVE_TIPS = "EVENT_LICENSE_ACTIVE_TIPS";
export const EVENT_SHOW_DESKTOP_PRO_VIP = "EVENT_SHOW_DESKTOP_PRO_VIP";
export const EVENT_SHOW_DIALOG_DRAWINDEX = "EVENT_SHOW_DIALOG_DRAWINDEX";
export const EVENT_OPEN_LIBRARY_ITEM = "EVENT_OPEN_LIBRARY_ITEM";
export const EVENT_INSERT_ITEM_NEW_LIBRARY = "EVENT_INSERT_ITEM_NEW_LIBRARY";
export const EVENT_SHOW_COMMON_INPUT = "EVENT_SHOW_COMMON_INPUT";

export const EVENT_SHOW_SNAP_LINE = "EVENT_SHOW_SNAP_LINE";

export const EVENT_NOTE_READONLY_STATUS = "EVENT_NOTE_READONLY_STATUS";
export const EVENT_NOTE_READONLY_STATUS_1 = "EVENT_NOTE_READONLY_STATUS_1";
export const EVENT_SET_NOTE_DATA = "EVENT_SET_NOTE_DATA";

export const EVENT_MOVE_FOLDER = "EVENT_MOVE_FOLDER";

export const EVENT_NEW_PROJECT = "EVENT_NEW_PROJECT";

export const EVENT_FILE_MODE_SMALL_TIP_VISIBLE = "EVENT_FILE_MODE_SMALL_TIP_VISIBLE";

export const EVENT_ELEMENT_DELETE = "EVENT_ELEMENT_DELETE";
export const EVENT_ELEMENT_DELETE_FROM_ACTION = "EVENT_ELEMENT_DELETE_FROM_ACTION";
export const EVENT_DELETE_ELEMENT = "EVENT_DELETE_ELEMENT";
export const EVENT_DELETE_ELEMENT_BY_ID = "EVENT_DELETE_ELEMENT_BY_ID";
export const EVENT_UPDATE_ELEMENT_BOUND = "EVENT_UPDATE_ELEMENT_BOUND";

export const EVENT_REFRESH_PDF_HIGHLIGHT = "EVENT_REFRESH_PDF_HIGHLIGHT";

export const EVENT_KEY_ESCAPSE = "EVENT_KEY_ESCAPSE";
export const EVENT_KEY_ESCAPSE_ESC = "EVENT_KEY_ESCAPSE_ESC";

export const EVENT_STICKYNOTE_SELECTION_CHANGE = "EVENT_STICKYNOTE_SELECTION_CHANGE";

export const EVENT_OPEN_SELECT_FONT_FAMILY = "EVENT_OPEN_SELECT_FONT_FAMILY";

export const EVENT_SHOW_TEMPLATE_DIALOG = "EVENT_SHOW_TEMPLATE_DIALOG";

export const EVENT_SHOW_MESSAGE_BOX = "EVENT_SHOW_MESSAGE_BOX";

export const EVENT_REFRESH_LOGIN_STATUS = "EVENT_REFRESH_LOGIN_STATUS";

export const EVENT_SWITCH_HOME_LIST_MENU="EVENT_SWITCH_HOME_LIST_MENU";

export const EVENT_REFRESH_USER_IFNO = "EVENT_REFRESH_USER_IFNO";

export const EVENT_WINDOW_BAR_VISIBLE = "EVENT_WINDOW_BAR_VISIBLE";

export const EVENT_MINDMAP_PREVIEW_ATTACH = "EVENT_MINDMAP_PREVIEW_ATTACH";
export const EVENT_MINDMAP_ADD_PDF = "EVENT_MINDMAP_ADD_PDF";
export const EVENT_MINDMAP_ADD_CARD = "EVENT_MINDMAP_ADD_CARD";
export const EVENT_MINDMAP_DELETE_CARD = "EVENT_MINDMAP_DELETE_CARD";
export const EVENT_MINDMAP_ADD_IMAGE = "EVENT_MINDMAP_ADD_IMAGE";
export const EVENT_MINDMAP_ADD_LINK = "EVENT_MINDMAP_ADD_LINK";
export const EVENT_MINDMAP_LINK_INFO = "EVENT_MINDMAP_LINK_INFO";
export const EVENT_MINDMAP_LINE_COLOR = "EVENT_MINDMAP_LINE_COLOR";
export const EVENT_MINDMAP_LINE_COLOR_OK = "EVENT_MINDMAP_LINE_COLOR_OK";
export const EVENT_PASTE_FILE_MESSAGE = "EVENT_PASTE_FILE_MESSAGE";
export const EVENT_ON_DOUBLE_CLICK = "EVENT_ON_DOUBLE_CLICK";
export const EVENT_MINDMAP_REMOVE_ATTACH = "EVENT_MINDMAP_REMOVE_ATTACH"

export const EVENT_CHOOSE_INSERT_PDF_FILE = "EVENT_CHOOSE_INSERT_PDF_FILE";

export const EVENT_UPDATE_FRAME_SORT = "EVENT_UPDATE_FRAME_SORT";

export const EVENT_UPDATE_ELEMENT_HAS_UPDATE = "EVENT_UPDATE_ELEMENT_HAS_UPDATE";

export const EVENT_UPDATE_FRAME_LIST = "EVENT_UPDATE_FRAME_LIST";

export const EVENT_CANVAS_REFRESH_ELEMENT_COUNT = "EVENT_CANVAS_REFRESH_ELEMENT_COUNT";

export const EVENT_SELECT_ELEMENT_IN_CANVAS_BY_ELEID = "EVENT_SELECT_ELEMENT_IN_CANVAS_BY_ELEID";

export const EVENT_UPDATE_NOTE_HEIGHT = "EVENT_UPDATE_NOTE_HEIGHT";

export const EVENT_UPDATE_CANVAS_NOTE_TO_DB = "EVENT_UPDATE_CANVAS_NOTE_TO_DB";

export const EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO = "EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO";

export const EVENT_CANVAS_SELECTION_CHANGED = "EVENT_CANVAS_SELECTION_CHANGED";

export const EVENT_CANVAS_EXPAND_STATS_CHANGED = "EVENT_CANVAS_EXPAND_STATS_CHANGED";

export const EVENT_SAVE_TO_SERVER = "EVENT_SAVE_TO_SERVER"

export const EVENT_UPDATE_FONT_SIZE = "EVENT_UPDATE_FONT_SIZE";

export const EVENT_MAX_DRAG_IMAGE = "EVENT_MAX_DRAG_IMAGE";

export const EVENT_DELETE_PDF_FROM_DIALOG = "EVENT_DELETE_PDF_FROM_DIALOG";

export const EVENT_RICH_TEXT_SELECTED = "EVENT_RICH_TEXT_SELECTED";

export const EVENT_HIDDEN_FLOAT_MENU = "EVENT_HIDDEN_FLOAT_MENU";

export const EVENT_CLEAR_CANVAS= "EVENT_CLEAR_CANVAS";

export const EVENT_TOGGLE_THEME = "EVENT_TOGGLE_THEME";

export const EVENT_STROKE_COLOR_CHANGE = "EVENT_STROKE_COLOR_CHANGE";
export const EVENT_BACKGROUND_COLOR_CHANGE = "EVENT_BACKGROUND_COLOR_CHANGE";
export const EVENT_FONT_STROKE_COLOR_CHANGE = "EVENT_FONT_STROKE_COLOR_CHANGE";
export const EVENT_FORCE_UPDATE_TOOLBAR_MENU = "EVENT_FORCE_UPDATE_TOOLBAR_MENU";

export const EVENT_SHOW_FONT_CHOOSE = "EVENT_SHOW_FONT_CHOOSE";

export const EVENT_SHOW_PROGRESS = "EVENT_SHOW_PROGRESS";

export const EVENT_UPDATE_FRAME_NAME = "EVENT_UPDATE_FRAME_NAME";

export const EVENT_ONSCROLL_TO_ELEMENT = "EVENT_ONSCROLL_TO_ELEMENT";

export const EVENT_SHOW_CONTEXT_MENU = "EVENT_SHOW_CONTEXT_MENU";

export const EVENT_FRAME_POINTER_UP = "EVENT_FRAME_POINTER_UP";

export const EVENT_TEST_ONDRAG_NOTE="EVENT_TEST_ONDRAG_NOTE";

export const EVENT_PDF_ON_SLIDER_RIGHT = "EVENT_PDF_ON_SLIDER_RIGHT"
export const EVENT_NOTE_ON_SLIDER_RIGHT = "EVENT_NOTE_ON_SLIDER_RIGHT";
export const EVENT_VIDEO_ON_SLIDER_RIGHT = "EVENT_VIDEO_ON_SLIDER_RIGHT";
export const EVENT_PROJECT_ON_SlIDER_RIGHT = "EVENT_PROJECT_ON_SlIDER_RIGHT";
export const EVENT_WEBLINK_ON_SLIDER_RIGHT = "EVENT_WEBLINK_ON_SLIDER_RIGHT";
export const EVENT_SHOW_IMPORT_FILE_VIP = "EVENT_SHOW_IMPORT_FILE_VIP";
export const EVENT_SHOW_IMPORT_FONT_VIP = "EVENT_SHOW_IMPORT_FONT_VIP";
export const EVENT_REFRESH_DRAW_FAVOR = "EVENT_REFRESH_DRAW_FAVOR";

export const EVENT_FRAME_MAKE_COPY = "EVENT_FRAME_MAKE_COPY";

export const EVENT_DELETE_HTML_NOTE = "EVENT_DELETE_HTML_NOTE";

export const EVENT_CHANGE_THEME = "EVENT_CHANGE_THEME";

export const KEY_MACHINEID = "mid";

export const KEY_TABLEVIEW_TAG_BACKGROUND_INDEX = "KEY_TABLEVIEW_TAG_BACKGROUND_INDEX";

export const KEY_FREE_DRAW_STROKE_WIDTH = "KEY_FREE_DRAW_STROKE_WIDTH";

export const KEY_DRAW_ARROW_STROKE_WIDTH = "KEY_DRAW_ARROW_STROKE_WIDTH";

export const KEY_DRAW_ARROW_LINE_STYLE = "KEY_DRAW_ARROW_LINE_STYLE";

export const KEY_DRAW_ARROW_STROKE_COLOR = "KEY_DRAW_ARROW_STROKE_COLOR";

export const KEY_HOME_LEFT_MENU_CUSTOMIZE = "customLeftMenu";

export const KEY_HAS_DEFAULT_HOME = "hasDefaultHome"

export const KEY_CUSTOMIZE_HOME_20241209 = "KEY_CUSTOMIZE_HOME_20241209";
export const KEY_CUSTOMIZE_HOME_REMIND_ME_LATER = "KEY_CUSTOMIZE_HOME_REMIND_ME_LATER";

export const KEY_DEFAULT_PROJECT_ID = "default_project_id_";

export const KEY_WEB_MACHINEID = "web_mid";

export const KEY_HOME_SELECT_ITEM = "homeSelectItem";

export const KEY_NEW_PROJECT_ID = "newProjectId";

export const KEY_CARD_CURSOR_POS_ = "card_cursor_pos_";

export const KEY_SLIDER_RIGHT_WIDTH = "sliderWidth";
export const KEY_SLIDER_RIGHT_LIBRARY_WIDTH = "sliderWidth";//保存同一个宽度...
export const KEY_DRAW_LEFT_MENU_WIDTH = "drawLeftWidth";

export const FROM_LIBRARY = "from_library";
export const FROM_TRASH = "from_trash";
export const FROM_TAG = "from_tag";
export const FROM_HOME = "from_home";
export const FROM_HOME_LIBRARY = "from_home_library";
export const FROM_HOME_DIALOG = "from_home_dialog";
export const FROM_ADD = "from_add"
export const FROM_JOURNAL = "from_journal"
export const FROM_SIDEBAR_FOLD = "from_sidebar_fold";
export const FROM_RIGHT_SIDEBAR = "from_right_sidebar";
export const FROM_HISTORY = "from_history";
export const FROM_PAGE_CARD = "from_page_card";
export const FROM_SHARE_CARD = "from_share_card";
export const FROM_CANVAS = "from_canvas";
export const FROM_PDF = "from_pdf"
export const FROM_HOME_HIGHLIGHT = "from_home_highlight";
export const FROM_LINK_TO_PROJECT = "from_link_to_project";
export const FROM_DIALOG = "from_dialog";
export const FROM_RIGHT_SIDE = "from_right_side";

export const IMPORT_FILE_MODE_ASKME = "askMe";
export const IMPORT_FILE_MODE_IMPORTMODE = "importMode";
export const IMPORT_FILE_MODE_LINKMODE = "linkMode";

export const KEY_USER_INFO = 'uinfo';

export const KEY_RANDOM = 'm&u*e12';

export const KEY_LINK_TAB = "keyLinkTab";
export const KEY_LINK_CARD_TAB = "keyLinkCardTab";

export const KEY_HAS_INITED = "hasInited-default";

export const KEY_HAS_INITED_OLD_PROJECT = "hasInited";

export const KEY_LAUNCH_TIMES = "launchTimes";

export const KEY_DRAW_LEFT_COLLAPSE = "drawLeftCollapse";
export const KEY_IS_FIRST_CLICK_FILE_MODE = "isFirstClickFileMode";

export const KEY_PROJECT_THUMB_INDEX = 'projectThumbIndex';

export const KEY_DRAW_BOARD_HEIGHT = 'drawBoardHeight_1';//改note为content 之前的drag高度不要了。
export const KEY_DRAW_FRAME_HEIGHT = 'drawFrameHeight_1';
export const KEY_DRAW_CARD_HEIGHT = 'drawCardHeight_1';
export const KEY_FILE_IMPORT_MODE = "fileImportMode";
export const KEY_FILE_IMPORT_MODE_LIBRARY = "fileLibraryDialogImportMode"
export const KEY_FILE_SIZE_SPLIT = "fileSizeSplit";
export const KEY_FILE_SIZE_SMALLER_THEN_MODE = "fileSizeSmallerThenMode";
export const KEY_FILE_SIZE_LARGER_THEN_MODE = "fileSizeLargerThenMode";
export const KEY_AUTO_BACKUP_INTERVAL = "autoBackupInterval";

export const KEY_GLOBAL_DOUBLE_CLICK_ELEMENT = "globalDoubleClickElemnet"
export const KEY_GLOBAL_INFO_VISIBLE = "globalInfoVisible";
export const KEY_GLOBAL_SNAP_LINE_VISIBLE = "globalSnapLineVisible";
export const KEY_GLOBAL_CONNECTOR_TYPE = "globalConnectorType";
export const KEY_GLOBAL_CARD_DISPLAY_MODE = "globalCardDisplayMode";
export const KEY_GLOBAL_SPELLCHECKER = "globalSpellChecker";
export const KEY_GLOBAL_YOUTUBE_EMBED_MODE = "globalYoutubeMode";
export const KEY_INIT_WEB_BOOKMARK = "initWebBookmark";
export const KEY_TEXT_HAS_BORDER = "textHasBorder";
export const KEY_STICKYNOTES_HAS_BORDER = "stickyNotesHasBorder";

export const KEY_GLOBAL_SYNC_AUTO_REFRESH_WHEN_OPEN_APP = "syncAutoRefreshOpenApp";
export const KEY_GLOBAL_SYNC_AUTO_SYNC_CLOSE_APP = "syncAutoSyncCloseApp";

export const KEY_GLOBAL_SHORTCUTS_CONFIG = "shortcutsConfig";
export const KEY_WEBVIEWER_CONFIG = "webviewerConfig";
export const KEY_QUICKNOTE_CONFIG = "quickNoteConfig";
export const KEY_APP_VERSION = "app_version";

export const KEY_LAST_SYNC_TIME = "lastSyncTime";

export const KEY_ENABLE_AUTO_BACKUP = "KEY_ENABLE_AUTO_BACKUP";
export const KEY_BACKUP_PATH = "KEY_BACKUP_PATH";
export const KEY_AUTO_BACKUP_PATH = "KEY_AUTO_BACKUP_PATH";
export const KEY_LAST_BACKUP_TIME = "KEY_LAST_BACKUP_TIME";

export const KEY_CARD_SORT_TYPE = "cardSortType";
export const KEY_CARD_ORDER_BY = "cardOrderBy";
export const KEY_CARD_VIEW_STYLE = "cardViewStyle";

export const KEY_HIGHLIGHT_SORT_TYPE = "highlightSortType";
export const KEY_HIGHLIGHT_ORDER_BY = "highlightOrderBy"

export const KEY_CANVAS_NOTE_SORT_TYPE = "canvasNoteSortType";
export const KEY_CANVAS_NOTE_ORDER_BY = "canvasNoteOrderBy";

export const KEY_TAGITEM_SORT_TYPE = "tagItemSortType";
export const KEY_TAGITEM_ORDER_BY = "tagItemOrderBy";

export const KEY_PROPERTY_LIST_STATUS = "KEY_PROPERTY_LIST_STATUS";

export const KEY_LIBRARY_SELECTED_TYPES = "libraryTypes";
export const KEY_HIGHLIGHT_SELECTED_TYPES = "highlightTypes";

export const KEY_TAG_TILTER_SELECTED_TYPES = "tagFilterLibraryTypes";

export const KEY_LIBRARY_TYPE = "libraryType";

export const KEY_UPGRADE_DATA_20240717 = 'upgradeData240717'
export const KEY_UPGRADE_DATA_20241030 = 'upgradeData241030'
export const KEY_UPGRADE_DATA_20241205 = 'upgradeData241205'
export const KEY_UPGRADE_DATA_20241206 = 'upgradeData241206-2'
export const KEY_UPGRADE_DATA_20241219 = 'KEY_UPGRADE_DATA_20241219'
export const KEY_IS_MAX_SIZE = 'KEY_IS_MAX_SIZE';

/**
 * 视图类型
 */
export const SYS_CONFIG_KEY_VIEW_STYLE = "viewStyle";

export const SYS_CONFIG_KEY_APPFIRST = "appFirst";
export const SYS_CONFIG_KEY_STORE_TIPS = "appStoreTips";

export const SYS_CONFIG_DEV_MODE = "devMode";
export const SYS_CONFIG_FREE_CARD_MODE = "freeCardMode";

/**
 * 排序类型
 */
export const SYS_CONFIG_KEY_SORT_TYPE = "sortType";
export const SYS_CONFIG_KEY_ORDER_BY = "orderBy";

export const SYS_CONFIG_KEY_AUTOUPDATE = "autoUpdate";
export const SYS_CONFIG_KEY_THEME = "theme";
export const SYS_CONFIG_KEY_DATEFORMAT = "dateformat";
export const SYS_CONFIG_KEY_LANGUAGE_CODE = "languageCode";

export const THEME_DARK = "dark";
export const THEME_LIGHT = "light"
/**
 * 默认时间格式
 */
export const DEFAULT_DATE_FORMAT = "yyyy-MM-dd"


export const LOGIN_ACCOUNT = "loginAccount";
export const LOGIN_USERNAME = "userName";
export const ACCESS_TOKEN = "access_token";
export const LIC = "lic";
export const EXPIRE_TIME = "expire_time";


export const DRAW_LINK_CLICK = "drawLinkClick";
export const LINK_INFO_TYPE_PROJECT = "project";
export const LINK_INFO_TYPE_LIBRARY = "library";
export const LINK_INFO_TYPE_HIGHLIGHT = "highlight";
export const LINK_INFO_TYPE_PDF_HIGHLIGHT = "pdfAnno";
export const LINK_INFO_TYPE_VIDEO_HIGHLIGHT = "videoAnno";
export const LINK_INFO_TYPE_PAGE = "page";
export const LINK_INFO_TYPE_NOTE = "note";
export const LINK_INFO_TYPE_FRAME = "frame";
export const LINK_INFO_TYPE_PDF = "pdf";
export const LINK_INFO_TYPE_JOURNAL = "journal";
export const LINK_INFO_TYPE_URL = "link";
export const LINK_INFO_TYPE_FILE = 'file';//file.....
export const LINK_INFO_TYPE_ELEMENT = 'element';

export const ABCDEFG = "20kXwV9lYC";
export const FDLJKSJFLS="7fAelT0";
export const HAFAHA = 'lH';

const emitter = mitt();
export default emitter;
